/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BankAccountViewModel } from './BankAccountViewModel';
import {
    BankAccountViewModelFromJSON,
    BankAccountViewModelFromJSONTyped,
    BankAccountViewModelToJSON,
} from './BankAccountViewModel';
import type { PaymentDetailsSourceOfMoneyViewModel } from './PaymentDetailsSourceOfMoneyViewModel';
import {
    PaymentDetailsSourceOfMoneyViewModelFromJSON,
    PaymentDetailsSourceOfMoneyViewModelFromJSONTyped,
    PaymentDetailsSourceOfMoneyViewModelToJSON,
} from './PaymentDetailsSourceOfMoneyViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsDebitOrderBankAccountViewModel
 */
export interface PaymentDetailsDebitOrderBankAccountViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsDebitOrderBankAccountViewModel
     */
    premiumId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsDebitOrderBankAccountViewModel
     */
    premiumDebitOrderId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsDebitOrderBankAccountViewModel
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsDebitOrderBankAccountViewModel
     */
    bankAccountId: number;
    /**
     * 
     * @type {BankAccountViewModel}
     * @memberof PaymentDetailsDebitOrderBankAccountViewModel
     */
    bankAccount: BankAccountViewModel;
    /**
     * 
     * @type {Array<PaymentDetailsSourceOfMoneyViewModel>}
     * @memberof PaymentDetailsDebitOrderBankAccountViewModel
     */
    sourcesOfMoney: Array<PaymentDetailsSourceOfMoneyViewModel>;
}

/**
 * Check if a given object implements the PaymentDetailsDebitOrderBankAccountViewModel interface.
 */
export function instanceOfPaymentDetailsDebitOrderBankAccountViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "bankAccountId" in value;
    isInstance = isInstance && "bankAccount" in value;
    isInstance = isInstance && "sourcesOfMoney" in value;

    return isInstance;
}

export function PaymentDetailsDebitOrderBankAccountViewModelFromJSON(json: any): PaymentDetailsDebitOrderBankAccountViewModel {
    return PaymentDetailsDebitOrderBankAccountViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsDebitOrderBankAccountViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsDebitOrderBankAccountViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'premiumId': !exists(json, 'PremiumId') ? undefined : json['PremiumId'],
        'premiumDebitOrderId': !exists(json, 'PremiumDebitOrderId') ? undefined : json['PremiumDebitOrderId'],
        'amount': json['Amount'],
        'bankAccountId': json['BankAccountId'],
        'bankAccount': BankAccountViewModelFromJSON(json['BankAccount']),
        'sourcesOfMoney': ((json['SourcesOfMoney'] as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelFromJSON)),
    };
}

export function PaymentDetailsDebitOrderBankAccountViewModelToJSON(value?: PaymentDetailsDebitOrderBankAccountViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PremiumId': value.premiumId,
        'PremiumDebitOrderId': value.premiumDebitOrderId,
        'Amount': value.amount,
        'BankAccountId': value.bankAccountId,
        'BankAccount': BankAccountViewModelToJSON(value.bankAccount),
        'SourcesOfMoney': ((value.sourcesOfMoney as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelToJSON)),
    };
}

